<div class="container">
    <div class="header">
        <div class="title">My Tasks</div>
        <div class="nav-quick-task" (click)="onCreateQuickTask($event)">+ Quick Task</div>
    </div>
    <div class="filter">
        <div class="status" *ngIf="showFilter">
            <tam-task-menu [config]="taskProcessorConfig" tid="task_assign_creat"></tam-task-menu>
            <tam-task-menu [config]="taskStatusConfig" tid="task_ongoing_closed"></tam-task-menu>
        </div>
    </div>
    <div class="content">
        <div class="no-data" [style.display]="showNoData()">
            <span>Your task list is empty.</span>
        </div>
        <div class="type-area">
            <div class="type">Quick Task</div>
        </div>
        <div class="task-list" infiniteScroll [infiniteScrollDistance]="scrollDownDistance"
            [infiniteScrollUpDistance]="scrollUpDistance" [infiniteScrollThrottle]="throttle"
            (scrolled)="onScrolledDown($event)" (scrolledUp)="onScrolledUp($event)" [infiniteScrollDisabled]="false"
            [scrollWindow]="false" [alwaysCallback]="true">
            <div class="task" *ngFor="let task of onePageTasks; trackBy:trackByFn" (click)="onItemSelect($event,task)"
                (touchstart)="onTouchstart()" (touchend)="onTouchend($event,task)"
                (contextmenu)="onContextMenu($event,task)"
                [ngClass]="selectItem && selectItem.id === task.id ? 'active' : ''">
                <task-list-item [task]="task"></task-list-item>
            </div>
            <tam-context-menu [config]="contextMenuConfig" *ngIf="contextMenuConfig"></tam-context-menu>
        </div>
    </div>
</div>